export const INLINE_LANGUAGE_OPTION_THRESHOLD = 3;
export const MOBILE_SINGLE_LIST_OPTION_THRESHOLD = 10;

export const REGIONAL_LAYOUT = {
  NONE: 'none',
  INLINE_LANGUAGE: 'inline-language',
  SINGLE_DROPDOWN: 'single-dropdown',
  INLINE_LANGUAGE_WITH_DROPDOWN: 'inline-language-with-dropdown',
  COMBINED_TRIGGER: 'combined-trigger',
};

export const MOBILE_SINGLE_PRESENTATION = {
  NONE: 'none',
  OPTION_LIST: 'option-list',
  DROPDOWN: 'dropdown',
};

const resolveMobileSinglePresentation = ({
  selectorCount,
  showLanguages,
  showCountries,
  languageCount,
  countryCount,
  currencyCount,
}) => {
  if (selectorCount !== 1) {
    return MOBILE_SINGLE_PRESENTATION.NONE;
  }

  const singleOptionCount = showLanguages
    ? languageCount
    : showCountries
    ? countryCount
    : currencyCount;

  return singleOptionCount < MOBILE_SINGLE_LIST_OPTION_THRESHOLD
    ? MOBILE_SINGLE_PRESENTATION.OPTION_LIST
    : MOBILE_SINGLE_PRESENTATION.DROPDOWN;
};

const classifyRegionalSettingsPresentation = ({
  languageCount = 0,
  countryCount = 0,
  currencyCount = 0,
} = {}) => {
  const showLanguages = languageCount > 1;
  const showCountries = countryCount > 1;
  const showCurrencies = currencyCount > 1;
  const selectorCount = [showLanguages, showCountries, showCurrencies].filter(
    Boolean
  ).length;
  const languageInline =
    showLanguages && languageCount <= INLINE_LANGUAGE_OPTION_THRESHOLD;
  const mobileSinglePresentation = resolveMobileSinglePresentation({
    selectorCount,
    showLanguages,
    showCountries,
    languageCount,
    countryCount,
    currencyCount,
  });

  let layoutMode = REGIONAL_LAYOUT.NONE;
  let singleSelectorType = null;
  let pairedSelectorType = null;

  if (selectorCount === 0) {
    return {
      selectorCount,
      layoutMode,
      showLanguages,
      showCountries,
      showCurrencies,
      languageInline: false,
      singleSelectorType,
      pairedSelectorType,
      mobileSinglePresentation,
    };
  }

  if (selectorCount === 1) {
    if (showLanguages) {
      singleSelectorType = 'language';
      layoutMode = languageInline
        ? REGIONAL_LAYOUT.INLINE_LANGUAGE
        : REGIONAL_LAYOUT.SINGLE_DROPDOWN;
    } else if (showCountries) {
      singleSelectorType = 'country';
      layoutMode = REGIONAL_LAYOUT.SINGLE_DROPDOWN;
    } else {
      singleSelectorType = 'currency';
      layoutMode = REGIONAL_LAYOUT.SINGLE_DROPDOWN;
    }

    return {
      selectorCount,
      layoutMode,
      showLanguages,
      showCountries,
      showCurrencies,
      languageInline,
      singleSelectorType,
      pairedSelectorType,
      mobileSinglePresentation,
    };
  }

  if (selectorCount === 2 && showLanguages && languageInline) {
    layoutMode = REGIONAL_LAYOUT.INLINE_LANGUAGE_WITH_DROPDOWN;
    pairedSelectorType = showCurrencies ? 'currency' : 'country';

    return {
      selectorCount,
      layoutMode,
      showLanguages,
      showCountries,
      showCurrencies,
      languageInline,
      singleSelectorType,
      pairedSelectorType,
      mobileSinglePresentation,
    };
  }

  layoutMode = REGIONAL_LAYOUT.COMBINED_TRIGGER;

  return {
    selectorCount,
    layoutMode,
    showLanguages,
    showCountries,
    showCurrencies,
    languageInline,
    singleSelectorType,
    pairedSelectorType,
    mobileSinglePresentation,
  };
};

export default classifyRegionalSettingsPresentation;
